<template>
    <div>
        <card>
            <b-row>
                <b-col>
                    <base-input label="Name" placeholder="Name" v-model="operation.name"></base-input>
                </b-col>
                <b-col>
                    <h5>Parser</h5>
                    <b-dropdown variant="outline-light" :text="parsers[operation.parser]">
                        <b-dropdown-item v-for="(parser,index) in parsers" v-bind:key="index" @click="parserChanged(index)">{{parser}}</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                <b-col>
                    <h5>Request handler</h5>
                    <b-dropdown variant="outline-light" :text="requestHandlers[operation.request_handler]">
                        <b-dropdown-item v-for="(handler,index) in requestHandlers" v-bind:key="index" @click="requestHandlerChanged(index)">{{handler}}</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                
                <b-col>
                    <base-input label="Continue key" placeholder="Continue key" v-model="operation.continue_key"></base-input>
                </b-col>
                <b-col>
                    <base-input label="Break key" placeholder="Break key" v-model="operation.break_key"></base-input>
                </b-col>
                <b-col>
                    <base-button icon type="info" @click="switchActions()">
                        <span class="btn-inner--icon">
                            <i :class="{'ni ni-fat-add':!showActions, 'ni ni-fat-delete':showActions}"/>
                        </span>
                    </base-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5>Is merger operation</h5>
                    <base-checkbox v-model="operation.is_merger_operation"></base-checkbox>
                </b-col>
                <b-col>
                    <h5>Proxy</h5>
                    <b-dropdown variant="outline-light" :text="proxies[operation.proxy]">
                        <b-dropdown-item v-for="(proxy,index) in proxies" v-bind:key="index" @click="proxyChanged(index)">{{proxy}}</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                <b-col>
                    <h5>Loop operation</h5>
                    <base-checkbox v-model="operation.loop_operation"></base-checkbox>
                </b-col>
                <b-col>
                    <base-button type="info" @click="switchHandlerParameters()">{{showHandlerParameters ? 'Hide handler parameters' : 'Show handler parameters'}}</base-button>
                </b-col>
            </b-row>
        </card>
        <card v-if="showHandlerParameters" class="handler-params">
            <h5 v-if="handlerParameters[operation.request_handler]===null || handlerParameters[operation.request_handler]===undefined || handlerParameters[operation.request_handler].length === 0">No parameters found for this handler</h5>
            <div v-else v-for="(parameterDetail,i) in handlerParameters[operation.request_handler]" :key="'handler-param-'+i">
                <base-input v-if="parameterDetail[2]==='number'" :label="parameterDetail[1]" :placeholder="parameterDetail[1]" type="number" v-model.number="operation.request_handler_params[parameterDetail[0]]" @input="clearHandlerParamIfNull(parameterDetail[0])"></base-input>
                <base-input v-if="parameterDetail[2]==='text'" :label="parameterDetail[1]" :placeholder="parameterDetail[1]" type="text" v-model="operation.request_handler_params[parameterDetail[0]]" @input="clearHandlerParamIfNull(parameterDetail[0])"></base-input>
                <div v-if="parameterDetail[2]==='checkbox'">
                    <h5>{{parameterDetail[1]}}</h5>
                    <base-checkbox v-model="operation.request_handler_params[parameterDetail[0]]"></base-checkbox>
                </div>
            </div>
        </card>
        <card v-if="parsers===null || requestHandlers===null">
            <p>Loading...</p>
        </card>
        <card v-else-if="showActions">
            <h2>Actions</h2>
            <b-row v-if="operation.actions.length===0">
                <b-col>No actions</b-col>
            </b-row>
            <div v-else v-for="(action,index) in operation.actions" :key="'action'+index" class="border-bottom p-2 mb-3">
                <base-button type="info" @click="addAction(index)">Add action</base-button>
                <div class="action-line">
                    <div class="action-line-buttons justify-content-end">
                        
                        <base-button icon type="info" @click="changeActionIndex(index,index-1)" class="btn-sm">
                            <span class="btn-inner--icon">
                                <i class="ni ni-bold-up"/>
                            </span>
                        </base-button>
                        <base-button icon type="info" @click="changeActionIndex(index,index+1)" class="btn-sm">
                            <span class="btn-inner--icon">
                                <i class="ni ni-bold-down"/>
                            </span>
                        </base-button>
                        <base-button icon type="info" @click="removeAction(index)" class="btn-sm">
                            <span class="btn-inner--icon">
                                <i class="ni ni-fat-remove"/>
                            </span>
                        </base-button>
                        <base-button icon type="info" @click="cloneAction(index)" class="btn-sm">
                            <span class="btn-inner--icon">
                                <i class="ni ni-single-copy-04"/>
                            </span>
                        </base-button>
                    </div>
                    <action :ref="'action_'+index" :action="action" :parserName="parsers[operation.parser]" :metadataKeys="operationMetadataKeys.slice(0,index)" @change="actionChanged"></action> 
                </div>
            </div>
            <base-button type="info" @click="addAction(-1)">Add action</base-button>
        </card>
    </div>
</template>

<script>
import Action from './Action.vue';

export default {
    name: 'operation',
    components:{
        Action,
    },
    props:{
        operation:Object,
        parsers:Object,
        requestHandlers:Object,
        proxies:Object,
    },
    data(){
        return {
            showActions:true, // Bu false başladığında action elemanları renderlanmadığından kayıtta sorun çıkıyor.
            showHandlerParameters:false,

            handlerParameters:{}, // Fonksiyonda içi dolacak.
            
            operationMetadataKeys:[],
        }
    },
    created(){
        this.setHandlerParameters();
        this.getOperationMetadataKeys();
    },
    methods:{
        switchActions(){
            if(this.showActions) // Burası panel kapanırken kapanmadan önce actionları almamızı sağlar. Panel kapalıyken action bilgileri alınamıyor (renderlanmadığı için)
                this.getActions();
            this.showActions=(!this.showActions);
        },
        switchHandlerParameters(){
            this.showHandlerParameters=!(this.showHandlerParameters);
        },
        addAction(index){
            var action={
                'action':undefined,
                'params':{}
            }
            index === -1 ? this.operation.actions.push(action) : this.operation.actions.splice(index,0,action);
            this.$forceUpdate();
        },
        removeAction(index){
            this.operation.actions.splice(index,1);
            this.$forceUpdate();
        },
        changeActionIndex(currentIndex,newIndex){
            if(newIndex<0)
                return;
            if(newIndex>=this.operation.actions.length)
                return;
            
            if(currentIndex<0)
                return;
            if(currentIndex>=this.operation.actions.length)
                return;
            
            var action=this.operation.actions[currentIndex];
            this.operation.actions[currentIndex]=this.operation.actions[newIndex];
            this.operation.actions[newIndex]=action;
            
            this.getOperationMetadataKeys();
            this.$forceUpdate();
        },
        getActions(){
            var i=0;
            this.operation.actions=[];
            while(true){
                var action=this.$refs["action_"+i];
                if(action===undefined || action.length==0)
                    break;

                action=action[0].action;
                action={
                    action:action.action,
                    params:action.params,
                    condition:action.condition,
                };

                if(action.condition===undefined)
                    delete action.condition

                this.operation.actions.push(action);
                i++;
            }
            return this.operation;
        },
        getOperation(){
            if(this.showActions) // Panel açıksa almayı dener. Değilse kapanırken alınan değeri döndürür.
                this.getActions();
            
            return this.operation;
        },
        parserChanged(index){ // TODO: Parser değiştikten sonra operasyonda yeni parserda olmayan bir işlem olmamalı
            this.operation.parser=index;
            this.$forceUpdate();
        },
        requestHandlerChanged(index){
            if(index=='null')
                index=null;
            this.operation.request_handler=index;
            this.operation.request_handler_params={};
            this.$forceUpdate();
        },
        proxyChanged(index){
            if(index=='null')
                index=null;
            this.operation.proxy=index;
            this.$forceUpdate();
        },
        actionChanged(event){
            this.getActions();
            if(event=='getMetadataKeys')
                this.getOperationMetadataKeys();
            
            this.$forceUpdate();
        },
        getOperationMetadataKeys(){
            this.operationMetadataKeys=[]
            for(var i in this.operation.actions){
                var action=this.operation.actions[i];
                var metadataKey=null;
                for(var j in action.params){
                    if(j=='to_metadata_key'){
                        metadataKey=action.params[j];
                        break;
                    }
                }
                this.operationMetadataKeys.push(metadataKey);
            }
        },
        setHandlerParameters(){
            // Ilk eleman parametre adı, ikincisi açıklaması, üçüncüsü tipi
            this.handlerParameters[1]=[ // requests
                ['sleep_after_request','Sleep after request','number'],
                ['max_retry','Max retry per request (default 5)','number']
            ];
            this.handlerParameters[4]=[ // cloudscraper
                ...this.handlerParameters[1], // Kalıtım alınan parametreler.
            ]
            this.handlerParameters[2]=[ // selenium
                ['sleep_after_request','Sleep after request (default 1)','number'],
                ['with_display','Start with display','checkbox'],
            ]
            this.handlerParameters[5]=[ // undetected_chromedriver
                ...this.handlerParameters[2],
            ]
            this.handlerParameters[6]=[ // network_listener. sleep_after_request default değeri değiştiği için seleniumdan kalıtım almadım.
                ['sleep_after_request','Sleep after request (default 10)','number'],
                ['with_display','Start with display','checkbox'],
            ]
        },
        clearHandlerParamIfNull(key){
            if(this.operation.request_handler_params[key]===''){
                delete this.operation.request_handler_params[key];
            }
        },
        cloneAction(index) {
            const selectedAction = {...this.operation.actions[index]};
    
            this.operation.actions.splice(index + 1, 0, selectedAction);
            this.$forceUpdate();
    }
    }
}
</script>

<style>
.operation-data {
    display :grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    background-color:darkgrey;
    margin-bottom: 10px;
    width:100%;
}

.operation-data * {
    margin: 20px;
}

.handler-params {
    display:flex;
    flex-direction: row;
}

.action-line {
    display: flex;
    flex-direction: column;
    gap: 10px;
    /* display: grid;
    grid-template-columns: 1fr 40fr; */
}

.action-line-buttons {
    display:flex;
    flex-direction: row;
}

.dropdown-header {
    color: black;
}

.parameters-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>